import * as React from 'react';
import OrganizationUser from '../models/OrganizationUser';
import Role from '../models/Role';
import HttpService from '../../core/services/HttpService';
import * as moment from 'moment'
import { withRouter } from "react-router-dom";
import { Grid, TextField, Typography, Button, DialogContentText, Divider, Chip, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';
import EditableChipList from '../../shared/components/EditableChipList';
import Form from '../../shared/components/Form';
import BreadCrumb from '../../shared/components/BreadCrumb'
import ConfirmationModal from '../../shared/components/ConfirmationModal';
import * as _ from 'lodash';
import HttpCallConfig from '../../core/models/HttpCallConfig'
import {defaultProvider} from '../../../constants'
import * as Languages from 'src/modules/consumer/models/Languages';

interface IState {
  availableRoles: Role[],
  removeConfirm: boolean;
  blockConfirm: boolean;
  activateConfirm: boolean;
  isOwnProfile: boolean;
}
const httpService = HttpService.Instance;

class UserForm extends React.Component<any, IState> {
  public formComponent: Form
  public isNewUser: boolean = true
  public userId: string
  constructor(props: any) {
    super(props);
    this.state = {
      availableRoles: [],
      removeConfirm: false,
      blockConfirm: false,
      activateConfirm: false,
      isOwnProfile: true
    }
    this.userId = this.props.match.params.userId;
    if (this.userId) { this.isNewUser = false }
    this.getUser = this.getUser.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  public editUserState(stateId: number) {
    const httpCallConfig = new HttpCallConfig;
    httpCallConfig.successMessage = 'Userstate updated'
    return httpService.post(process.env.REACT_APP_API_URL + 'users/' + this.userId + '/state', { id: stateId }, httpCallConfig)
  }

  public sendReinvite() {
    const httpCallConfig = new HttpCallConfig;
    httpCallConfig.successMessage = 'Invitation sent';
    return httpService.post(process.env.REACT_APP_API_URL + 'users/' + this.userId + '/reinvite', null, httpCallConfig)
  }

  public componentDidMount() {
    this.getUserRoles().then((data: any) => this.setState({ ...this.state, availableRoles: data.userRoles }))
  }

  public renderEnvironmentRoles(item: any, environmentIds: any, label: string, disabled: boolean) {
    const roles = item.roles.filter((role: any) => environmentIds.includes(role.environmentId));
    const availableRoles = item.availableRoles.filter((role: any) => environmentIds.includes(role.environmentId));
    if (!availableRoles.length) {
      return null;
    }
    return (
      <EditableChipList
        items={roles}
        itemOptions={availableRoles}
        handleAddItem={this.handleAddRole}
        handleDeleteItem={this.handleDeleteRole}
        labelProperty='name'
        label={label}
        disbaleDoubles
        disabled={disabled}
        />
    );
  }

  public getUserRoles() {
    return httpService.get(process.env.REACT_APP_API_URL + 'userroles')
      .then((response: Response) => response.json())
  }

  public getUser() {
    let availableRoles: Role[] = [];
    let user: OrganizationUser = new OrganizationUser();
    user.id = '',
      user.subdivision = '',
      user.firstName = '',
      user.lastName = '',
      user.email = '',
      user.dateAdded = '',
      user.preferredLanguageId = Languages.BritishEnglish.id,
      user.roles = [],
      user.state = {
        id: 2,
        name: 'INVITED'
      },
      user.identityProvider = defaultProvider
    let profile: OrganizationUser = new OrganizationUser()

    let getUser = new Promise((resolve, reject) => { resolve(user) });
    if (this.userId) {
      getUser = httpService.get(process.env.REACT_APP_API_URL + 'users/' + this.userId)
        .then((response: Response) => response.json())
        .then((data: any) => user = data)
    }
    const getUserRoles = httpService.get(process.env.REACT_APP_API_URL + 'userroles')
      .then((response: Response) => response.json())
      .then((data: any) => availableRoles = data.userRoles.reduce((acc: any[], item: any) => {
        acc.push({ id: item.id, name: item.name, assetName: item.assetName, environmentId: item.environmentId, description: item.description, subscriptionProvider: item.subscriptionProvider })
        return acc;
      }, []))
    const getProfile = httpService.get(process.env.REACT_APP_API_URL + 'userprofile/')
      .then((response: Response) => response.json())
      .then((data: any) => profile = data)

    return Promise.all([getUser, getUserRoles, getProfile])
      .then(() => {
        this.setState({ ...this.state, availableRoles, isOwnProfile: user.id === profile.id })
        user.assets = this.AssetDataReducer(user, availableRoles)
        return user
      })
  }

  public async saveData(data: OrganizationUser) {
    if (this.props.match.params.userId) {
      const httpCallConfig = new HttpCallConfig;
      httpCallConfig.successMessage = 'User updated'
      return await httpService.post(process.env.REACT_APP_API_URL + 'users/' + this.userId, data, httpCallConfig)
    }
    else {
      const httpCallConfig = new HttpCallConfig;
      httpCallConfig.successMessage = 'User added. ' + this.formComponent.formShadowData.firstName + ' should check his or her mailbox.'
      const response: Response = await httpService.post(process.env.REACT_APP_API_URL + 'users/', data, httpCallConfig)
      if (response.ok) {
        const orgUser: OrganizationUser = await response.json()
        await this.props.history.push('/organization/users/' + orgUser.id)
      }
      if (this.formComponent && this.formComponent.unblockNavigation) { this.formComponent.unblockNavigation(); }
      return response
    }
  }

  public AssetDataReducer(user: OrganizationUser, availableRoles: Role[]) {
    availableRoles.forEach(role => {
      if (!role.assetName) { role.assetName = 'Console' }
    });
    user.roles.forEach(role => {
      if (!role.assetName) { role.assetName = 'Console' }
    });

    const rolesGroepedByAsset = _(user.roles).groupBy('assetName')
      .map((roles, assetName) => ({ roles, name: assetName }))
      .value();

    const assets = _(availableRoles).groupBy('assetName')
      .map((availableRolesForAsset, assetName) => {
        const rolesGroepedAsset = _.find(rolesGroepedByAsset, { 'name': assetName })
        return ({
          availableRoles: availableRolesForAsset,
          name: assetName,
          subscriptionProvider: availableRolesForAsset[0] ? availableRolesForAsset[0].subscriptionProvider : null,
          roles: rolesGroepedAsset ? rolesGroepedAsset.roles : []
        })
      })
      .value();
    return assets;
  }

  public removeByIdAndEnvironment(array: any[], environmentId: any, id: any) {
    let indexOfMatch
    array.map((item, index) => {
      if (item.id === id && item.environmentId === environmentId) {
        // found it!
        indexOfMatch = index;
      }
    })
    if (indexOfMatch !== undefined) { array.splice(indexOfMatch, 1) }
    return array
  }

  public handleDeleteRole = (role: Role) => {
    this.formComponent.formShadowData.roles = this.removeByIdAndEnvironment(this.formComponent.formShadowData.roles, role.environmentId, role.id);
    this.formComponent.formShadowData.assets = this.AssetDataReducer(this.formComponent.formShadowData, this.state.availableRoles)
    this.formComponent.props.refreshHandler();
  }

  public handleAddRole = (role: Role) => {
    const newRoleSet = this.formComponent.formShadowData.roles;
    newRoleSet.push(role);
    this.formComponent.formShadowData.assets = this.AssetDataReducer(this.formComponent.formShadowData, this.state.availableRoles)
    this.formComponent.props.refreshHandler();
  }

  public render() {
    const hasNoCharacters = (value: string) => value.length <= 0
    const isDefaultUserProvider = (this.formComponent && this.formComponent.formData && this.formComponent.formData.identityProvider === defaultProvider) ? true : false;
    const isInvalidEmail = (email: string) => {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return hasNoCharacters(email) || !re.test(String(email).toLowerCase());
    }
    const isActive = (this.formComponent && this.formComponent.formData && this.formComponent.formData.state.id === 4)
    const isConfirmed = (this.formComponent && this.formComponent.formData && this.formComponent.formData.state.id === 3)
    const isBlocked = (this.formComponent && this.formComponent.formData && this.formComponent.formData.state.id === 5)
    const isInvited = (this.formComponent && this.formComponent.formData && this.formComponent.formData.state.id === 2)

    return (
      <div>
        <ConfirmationModal
          open={this.state.removeConfirm}
          onClose={() => this.setState({ ...this.state, removeConfirm: false })}
          onConfirm={() => {
            this.setState({ ...this.state, removeConfirm: false }, () => {
              this.editUserState(6).then((response) => {
                if (response.ok) {
                  this.props.history.push('/organization/users')
                }
              });
            });
          }}
        >
          <DialogContentText>Are you sure you want to remove this user? If logged in, this user will still be able to use the console until the user logs out ( or a period of max. 24h has passed ).</DialogContentText>
        </ConfirmationModal>
        
        {/* 
        TODO this can only be removed when CM-540 is approved
        <ConfirmationModal
          open={this.state.blockConfirm}
          onClose={() => this.setState({ ...this.state, blockConfirm: false })}
          onConfirm={() => {
            this.setState({ ...this.state, blockConfirm: false });
            this.editUserState(5)
              .then((response) => {
                if (response.ok) {
                  this.formComponent.formShadowData.state = { id: 5, name: 'BLOCKED' };
                  this.formComponent.formData.state = { id: 5, name: 'BLOCKED' };
                  this.forceUpdate();
                }
              })
          }}
        >
          <DialogContentText>Are you sure you want to block this user? If logged in, this user will still be able to use the console until the user logs out ( or a period of max. 24h has passed ).</DialogContentText>
        </ConfirmationModal>
        <ConfirmationModal
          open={this.state.activateConfirm}
          onClose={() => this.setState({ ...this.state, activateConfirm: false })}
          onConfirm={() => {
            this.setState({ ...this.state, activateConfirm: false });
            this.editUserState(4)
              .then((response) => {
                if (response.ok) {
                  this.formComponent.formShadowData.state = { id: 4, name: 'ACTIVE' };
                  this.formComponent.formData.state = { id: 4, name: 'ACTIVE' };
                  this.forceUpdate();
                }
              })
          }}
        >
          <DialogContentText>Are you sure you want to activate this user?</DialogContentText>
        </ConfirmationModal>
        */}
        <Grid container={true} spacing={24} justify="space-between">
          <Grid item={true}>
            <Typography color="textSecondary" gutterBottom={true}>
              <BreadCrumb
                value='Organization'
                to='/organization/settings/'
              />
              <BreadCrumb
                value='Users'
                to='/organization/users'
              />
              {this.formComponent && this.formComponent.formData && this.formComponent.formData.firstName + ' ' + this.formComponent.formData.lastName}
              {!this.userId && 'new'}
            </Typography>
          </Grid>
          <Grid item={true}>
            {(isActive || isConfirmed) && isDefaultUserProvider &&
              <Button
                className="margin-top-24"
                size="small"
                mini={true}
                aria-label="Add"
                aria-haspopup="true"
                href={process.env.REACT_APP_PASSWORD_RESET_URL}
                target='_blank'
              >
                Reset password
              </Button>
            }
            {/* 
            TODO this can only be removed when CM-540 is approved
            {isBlocked && !this.state.isOwnProfile && isDefaultUserProvider &&
              <Button size="small" onClick={() => this.setState({ ...this.state, activateConfirm: true })}>Activate User</Button>
            }
            {isActive && !this.state.isOwnProfile && isDefaultUserProvider &&
              <Button size="small" onClick={() => this.setState({ ...this.state, blockConfirm: true })}>Block User</Button>
            }
            */}
            {(isBlocked || isActive) && !this.state.isOwnProfile && isDefaultUserProvider &&
              <Button size="small" onClick={() => this.setState({ ...this.state, removeConfirm: true })}>Remove User</Button>
            }
            {isInvited && isDefaultUserProvider &&
              <Button size="small" onClick={() => { this.sendReinvite() }}>Resend invitation</Button>
            }
          </Grid>
        </Grid>
        <Form
          ref={(ref: Form) => this.formComponent = ref}
          history={this.props.history}
          saveFormPromise={this.saveData}
          getFormPromise={this.getUser}
          refreshHandler={
            (callback?: () => void) => {
              this.forceUpdate(() => {
                if (callback) { callback() }
              })
            }
          }
        >
          {this.formComponent && this.formComponent.formData && this.formComponent.formData.identityProvider !== defaultProvider &&
            <div className="padding-bottom-24">
              <Chip className='full-width' label={"This user is linked with external entity provider " + this.formComponent.formData.identityProvider + ". Some functionality is limited."} />
            </div>
          }
          {this.formComponent && this.formComponent.formShadowData &&
            <div>
              <Grid container={true} spacing={24}>
                <Grid item={true}>
                  <TextField
                    name="firstName"
                    label="First Name"
                    value={this.formComponent.formShadowData.firstName}
                    onChange={(e: any) => {
                      this.formComponent.onChangeHandler(e, { validation: hasNoCharacters })
                    }}
                    margin="normal"
                    required={true}
                    error={hasNoCharacters(this.formComponent.formShadowData.firstName)}
                    disabled={!isDefaultUserProvider}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="lastName"
                    label="Last Name"
                    value={this.formComponent.formShadowData.lastName}
                    onChange={(e: any) => {
                      this.formComponent.onChangeHandler(e, { validation: hasNoCharacters })
                    }}
                    margin="normal"
                    required={true}
                    error={hasNoCharacters(this.formComponent.formShadowData.lastName)}
                    disabled={!isDefaultUserProvider}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="email"
                    label="Email"
                    disabled={!(this.isNewUser) || !isDefaultUserProvider}
                    value={this.formComponent.formShadowData.email}
                    onChange={(e: any) => {
                      this.formComponent.onChangeHandler(e, { validation: isInvalidEmail })
                    }}
                    margin="normal"
                    required={true}
                    error={isInvalidEmail(this.formComponent.formShadowData.email)}
                  />
                </Grid>
                <Grid item={true}>
                  <TextField
                    name="subdivision"
                    label="Subdivision"
                    value={this.formComponent.formShadowData.subdivision}
                    onChange={(e: any) => { this.formComponent.onChangeHandler(e); }}
                    margin="normal"
                    disabled={!isDefaultUserProvider}
                  />
                </Grid>
              </Grid>
              {this.userId &&
                <Grid container={true} spacing={24}>
                  <Grid item={true}>
                    <TextField
                      name="stateName"
                      label="State"
                      disabled={true}
                      value={this.formComponent.formShadowData.state.name}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item={true}>
                    <TextField
                      name="dateAdded"
                      label="Date Added"
                      disabled={true}
                      value={moment(this.formComponent.formShadowData.dateAdded).format('YYYY-MM-DD')}
                      margin="normal"
                    />
                  </Grid>
                </Grid>
              }
              <Grid container={true} spacing={24} className="padding-bottom-24">
                <Grid item={true}>
                  <FormControl margin="normal" required>
                    <InputLabel>Preferred Language</InputLabel>
                    <Select
                      name="preferredLanguageId"
                      style={{width: 195}}
                      value={
                        this.formComponent.formShadowData.preferredLanguageId
                      }
                      onChange={(e: any) => {
                        this.formComponent.onChangeHandler(e);
                      }}
                      disabled={!isDefaultUserProvider}
                    >
                      {Object.values(Languages).map(language => (
                        <MenuItem key={language.id} value={language.id}>
                          {language.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>For limited use cases only</FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              <div className="padding-bottom-24" />
              <Divider />
              <div className="padding-bottom-24" />
              {this.formComponent.formShadowData.assets && this.formComponent.formShadowData.assets.map((item: any, index: number) =>
                <div key={index} className="padding-bottom-24">
                  <Typography variant="subheading" gutterBottom={true}>
                    {item.name + ' roles'} {item.subscriptionProvider && item.subscriptionProvider !== defaultProvider ? ' | (managed by ' + item.subscriptionProvider + ')' : ''}
                  </Typography>
                  {this.renderEnvironmentRoles(item, [0, null, undefined], 'All environments', !isDefaultUserProvider || item.subscriptionProvider ? item.subscriptionProvider !== defaultProvider : false)}
                  {this.renderEnvironmentRoles(item, [2], 'Live', !isDefaultUserProvider || item.subscriptionProvider ? item.subscriptionProvider !== defaultProvider : false)}
                  {this.renderEnvironmentRoles(item, [1], 'Sandbox', !isDefaultUserProvider || item.subscriptionProvider ? item.subscriptionProvider !== defaultProvider : false)}
                </div>
              )}
              <div className="padding-bottom-24" />
              <Divider />
              <div className="padding-bottom-24" />
            </div>
          }
        </Form>
      </div>
    )
  }
}

export default withRouter(UserForm)



// WEBPACK FOOTER //
// ./src/modules/organization/components/UserForm.tsx